import { AnhangDataType } from '@eBeihilfe/einreichung-shared/model';
import { AnhangDtoModel, ConfigSettingsService, ConverterService, EndToEndEncrypter } from '@ebeihilfe/core';
import { EinreichungApiService } from '@eBeihilfe/einreichung-shared/services';
import { Seite } from './Seite';
import { inject } from '@angular/core';

export abstract class SeiteFactory {
  protected readonly configService = inject(ConfigSettingsService);
  protected readonly einreichungsApi = inject(EinreichungApiService);
  protected readonly endToEndEncrypter = inject(EndToEndEncrypter);
  protected readonly converterService = inject(ConverterService);

  public abstract CreateSeite(): Seite;

  public async CreateFromSeitenInfo(seitenInfo: AnhangDtoModel): Promise<Seite> {
    const seite = this.CreateSeite();

    if (seitenInfo.thumbnail) {
      seite.dataType = seitenInfo.dataType as AnhangDataType;
      seite.id = seitenInfo.id;
      seite.thumb = seitenInfo.thumbnail;
      seite.uploaded = true;
      seite.setSize(seitenInfo.blobLen);
      return seite;
    }
    return seite;
  }
}
